module.exports = __webpack_public_path__ + "static/media/sell_process_steps-slow.63ee7d56.gif";